import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useCreatePointSlab = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('createPointSlab', {
    onSuccess: async (response: { message?: string }) => {
      toast.success(response.message);
      await queryClient.invalidateQueries({ queryKey: ['point-management', 'slabs'] });
    },
    onError: (error: { message: string }) => toast.error(error.message),
  });

  return { mutateAsync, isPending };
};

export const useUpdatePointSlab = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('updatePointSlab', {
    onSuccess: async (response: { message?: string }) => {
      toast.success(response.message);
      await queryClient.invalidateQueries({ queryKey: ['point-management', 'slabs'] });
    },
    onError: (error: { message: string }) => toast.error(error.message),
  });

  return { mutateAsync, isPending };
};

export const useUpdatePointSlabStatus = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('updatePointSlabStatus', {
    onSuccess: async (response: { message?: string }) => {
      toast.success(response.message);
      await queryClient.invalidateQueries({ queryKey: ['point-management', 'slabs'] });
    },
    onError: (error: { message: string }) => toast.error(error.message),
  });

  return { mutateAsync, isPending };
};

export const useDeletePointSlab = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('deletePointSlab', {
    onSuccess: async (response: { message?: string }) => {
      toast.success(response.message);
      await queryClient.invalidateQueries({ queryKey: ['point-management', 'slabs'] });
    },
    onError: (error: { message: string }) => toast.error(error.message),
  });

  return { mutateAsync, isPending };
};
